module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dialog-panel"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.panelOpen && _vm.options && _vm.options.length > 0) ? _c('div', {
    staticClass: "dialog-panel__click-block"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.panelOpen) ? _c('div', {
    staticClass: "dialog-panel__container padding--large"
  }, [_c('img', {
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-secondary"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.options && _vm.options.length > 0) ? _c('ul', {
    staticClass: "options list-inline"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('li', {
      staticClass: "options__item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onOptionClick(index)
        }
      }
    }, [_vm._v(_vm._s(option.optionText))])])
  })) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-901ed88e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DialogPanel/DialogPanel.vue
// module id = 561
// module chunks = 1